import { render, staticRenderFns } from "./OrderDetailsCard.vue?vue&type=template&id=55d024f5&scoped=true&"
import script from "./OrderDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailsCard.vue?vue&type=style&index=0&id=55d024f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d024f5",
  null
  
)

export default component.exports